import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import { CrudUserFracttal } from '../../api/CrudUserFracttal.api'
import LoginContext from '../../context/login_context/LoginContext';
import { Button, Drawer, TextField } from '@mui/material';

// icons
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

export const CrudUsers = () => {

    const {LoginState} = useContext(LoginContext);
    // console.log(LoginState)

    const [UserListFracttal, setUserListFracttal] = useState([])
    const [UserSelected, setUserSelected] = useState(null)

    const [UserRut_N, setUserRut_N] = useState("")
    const [UserName_N, setUserName_N] = useState("")
    const [UserCorreo_N, setUserCorreo_N] = useState("")

    const [stateDW_E, setStateDW_E] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_E = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setStateDW_E({ ...stateDW_E, [anchor]: open });
        setUserSelected(null)
    };

    const [stateDW_C, setStateDW_C] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_C = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
        setStateDW_C({ ...stateDW_C, [anchor]: open });
        setUserCorreo_N("")
        setUserName_N("")
        setUserRut_N("")
    };

    const ObtenerUsuarios = async () => {
      const data = {PLANTA:LoginState.planta}
      const response = await CrudUserFracttal(data, {ACTION: "READ"});
    //   console.log(response);
      await setUserListFracttal(response);
    }

    const EditUser = async (user) => {
        console.log(user, "EDIT")
        const response = await CrudUserFracttal(user, {ACTION: "UPDATE"});
        ObtenerUsuarios()
        setStateDW_E({ ...stateDW_E, ["bottom"]: false });
    }

    const DeleteUser = async (user) => {
        console.log(user, "DELETE")
        const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar al usuario ${user.NOMBRE}?`);
        if (!confirmDelete) {
            return;
        } else {
            const response = await CrudUserFracttal(user, {ACTION: "DELETE"});
            ObtenerUsuarios()
        }
    }

    const CreateUser = async (ev,data) => {
        ev.preventDefault()
        await CrudUserFracttal({RUT:UserRut_N,CODIGO:UserRut_N, NOMBRE:UserName_N, Email:UserCorreo_N, PLANTA:LoginState.planta}, {ACTION: "CREATE"})
        await ObtenerUsuarios()
        setStateDW_C({ ...stateDW_C, ["bottom"]: false });
    }

    useEffect(() => {
      ObtenerUsuarios();
    }, [])
    
  return (
    <>
        <HeaderMenu Pag_Sel={'crud_users'} />
        <div className='container'>
            <h1>Lista de Usuarios</h1>
            <div className='row'>
                <div className='col-12 mb-2 text-center'>
                    <Button variant="contained" onClick={toggleDrawer_C('bottom', true)}><span className='mr-2'>CREAR USUARIO</span><GroupAddIcon /></Button>
                </div>
                <div className='table-responsive'>
                    <table className='table table-striped table-bordered table-sm'>
                        <thead className='bg-dark text-white'>
                            <tr>
                                <th>Rut</th>
                                <th>Nombre</th>
                                <th>Correo</th>
                                <th>Planta</th>
                                <th>Accion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                UserListFracttal&&UserListFracttal.map((user, index) => (
                                    <tr key={index}>
                                        <td>{user.RUT}</td>
                                        <td>{user.NOMBRE}</td>
                                        <td>{user.Email}</td>
                                        <td>{user.PLANTA}</td>
                                        <td className='text-center'>
                                            <span>
                                                <EditNoteIcon
                                                    onClick={()=>{
                                                        setStateDW_E({ ...stateDW_E, ['bottom']: true })
                                                        setUserSelected(user)
                                                    }}
                                                    color='info'
                                                />
                                            </span>
                                            <span className='ml-3'>
                                                <DeleteIcon
                                                    onClick={()=>DeleteUser(user)}
                                                    color='error'
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div> 
            </div>
        </div>
        
        {/* drawer EDIT */}
        <Drawer
            anchor={'bottom'}
            open={stateDW_E['bottom']}
            onClose={toggleDrawer_E('bottom', false)}
        >
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 bg-info text-white p-2 mb-3'>
                        <span className='lead'><b>Editar Usuario</b></span>
                    </div>
                </div>
            </div>
            <div className='container mb-5'>
                <div className='row'>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField id="outlined-basic"
                        fullWidth
                        label="RUT"
                        value={UserSelected?UserSelected.RUT:''}
                        focused
                        onChange={(e) => setUserSelected({...UserSelected,["RUT"]:e.target.value})}
                        size='small'
                        variant="outlined" />
                    </div>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField id="outlined-basic"
                        fullWidth
                        label="NOMBRE"
                        value={UserSelected?UserSelected.NOMBRE:''}
                        focused
                        onChange={(e) => setUserSelected({...UserSelected,["NOMBRE"]:e.target.value})}
                        size='small'
                        variant="outlined" />
                    </div>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField id="outlined-basic"
                        fullWidth
                        label="CORREO"
                        value={UserSelected?UserSelected.Email:''}
                        focused
                        onChange={(e) => setUserSelected({...UserSelected,["Email"]:e.target.value})}
                        size='small'
                        variant="outlined" />
                    </div>
                    <div className='col-12 my-2 text-right'>
                        <Button variant="contained" onClick={()=>EditUser(UserSelected)}>
                            <span className='mr-2'>EDITAR USUARIO</span><EditNoteIcon />
                        </Button>
                    </div>
                </div>
            </div>
            
        </Drawer>

        {/* drawer CREATE */}
        <Drawer
            anchor={'bottom'}
            open={stateDW_C['bottom']}
            onClose={toggleDrawer_C('bottom', false)}
        >
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 bg-success text-white p-2 mb-3'>
                        <span className='lead'><b>Agregar Usuario</b></span>
                    </div>
                </div>
            </div>
            <div className='container mb-5'>
                {/* <div > */}
                <form className='row' onSubmit={async(e)=>CreateUser(e,{RUT:UserRut_N,CODIGO:UserRut_N, NOMBRE:UserName_N, Email:UserCorreo_N, PLANTA:LoginState.planta})}>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField
                            id="outlined-basic"
                            fullWidth
                            label="RUT"
                            value={UserRut_N}
                            onChange={(e)=>setUserRut_N(e.target.value)}
                            size='small'
                            variant="outlined" />
                    </div>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField
                            id="outlined-basic"
                            fullWidth
                            label="NOMBRE"
                            value={UserName_N}
                            onChange={(e)=>setUserName_N(e.target.value)}
                            size='small'
                            variant="outlined" />
                    </div>
                    <div className='col-12 col-md-4 my-2'>
                        <TextField
                            id="outlined-basic"
                            fullWidth
                            type='email'
                            label="CORREO"
                            value={UserCorreo_N}
                            onChange={(e)=>setUserCorreo_N(e.target.value)}
                            size='small'
                            variant="outlined" />
                    </div>
                    <div className='col-12 my-2 text-right'>
                        <Button
                            type='submit'
                            variant="contained"
                            disabled={UserRut_N===""||UserCorreo_N===""||UserName_N===""?true:false}>
                            <span className='mr-2'>
                                AGREGAR USUARIO
                            </span>
                            <GroupAddIcon />
                        </Button>
                    </div>
                </form>
                {/* </div> */}
            </div>
        </Drawer>
    </>
  )
}
